import Certificate from "../../../formability/certificateBuilder/models/certificate";
import NavigableValidation from "./navigableValidation";
import EmbeddedCollectionValidator from "../navigableValidators/embeddedCollectionValidator";
import NavigableValidator from "../navigableValidators/navigableValidator";
import {ValidationModalSection} from "~/models/navigableValidations/validationSections";
import PageCertificateElement from "../../../formability/certificateBuilder/models/pageCertificateElement";

export default class PageCertificateElementValidation extends NavigableValidation<PageCertificateElement> {
  model: PageCertificateElement;

  validators: NavigableValidator<Certificate>[] = [
    new EmbeddedCollectionValidator({
      validatorKey: 'certificate_elements',
      section: ValidationModalSection.Fields
    }, this.model),
  ];

  getPath(validatorKey, value?): string {
    const propNames = validatorKey.split('.');
    const propName = propNames[0];
    switch (propName) {
      default:
        return `${this.getPageArea(propName).toLowerCase()}#${propName}`;
    }
  }
}